import * as React from 'react';

import {Button} from 'shells/button/button';
import {IconButton} from 'shells/button/icon-button/icon-button';
import {NavIconSettingsIcon} from 'shells/icon/navigation/nav-icon-settings';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {GetNotifications_notifications as Notification} from 'nutshell-graphql-types';

import {useMarkAllNotificationsRead} from '../../../sidebar/graphql/hooks';

import {appHistory} from '../../../../history';

type Props = {
    setIsNotificationsOpened: (arg1: boolean) => void;
    notifications: Array<Notification>;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
};

export const Header = (props: Props) => {
    const {markAllRead} = useMarkAllNotificationsRead();

    return (
        <div className='flex justify-sb pad-16 pb-8 border-bottom'>
            <StackLegacy isHorizontal={true} spacing={8} alignCenter={true}>
                <Body color='dark' size='large' isBold={true}>
                    Notifications
                </Body>
                <div className='mt-4'>
                    <IconButton
                        icon={NavIconSettingsIcon}
                        noHoverBackground={true}
                        noPadding={true}
                        onClick={() => {
                            appHistory.push('/my-account/notifications');
                            props.setIsNotificationsOpened(false);
                        }}
                        tooltipText='Notification settings'
                    />
                </div>
            </StackLegacy>
            {props.notifications.length && !props.isLoading && !props.error ? (
                <Button
                    variant='text-primary'
                    onClick={() => markAllRead().then(() => props.refetch())}
                >
                    Mark all as read
                </Button>
            ) : null}
        </div>
    );
};
